import { __rest } from "tslib";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import getMenuItems from '../menuItems/getMenuItems';
import menuItemsPropTypes from './menuItemsPropTypes';
import MenuItems from '../menuItems/MenuItems';
const DropdownSubmenu = props => {
    const { title, items, disabled, className } = props, remainingProps = __rest(props, ["title", "items", "disabled", "className"]);
    const classes = classNames('dropdown-submenu', disabled && 'disabled', className && className);
    return (_jsxs("li", Object.assign({}, remainingProps, { className: classes }, { children: [_jsxs("a", Object.assign({ className: 'submenu-title' }, { children: [_jsx("span", Object.assign({ className: 'submenu-title-text' }, { children: title })), _jsx("span", { className: 'rioglyph rioglyph-menu-right' })] })), _jsx(MenuItems, { children: getMenuItems(items) })] })));
};
DropdownSubmenu.defaultProps = {
    title: '',
    items: [],
    disabled: false,
};
DropdownSubmenu.propTypes = {
    title: PropTypes.oneOfType([PropTypes.node, PropTypes.string]),
    items: menuItemsPropTypes,
    disabled: PropTypes.bool,
    className: PropTypes.string,
};
export default DropdownSubmenu;
